import { useEffect } from 'react';
import { TASK_LOGIN_NOTICE_DELAY_MS, loginNotice } from '@agrogruda/shared';
import { useAuth } from '@/auth/useAuth';
import { useToast } from '@/components/ui/Toast';
import { useTasksData } from './useTasksData';

/** Logins already notified during this page load (prototype: once per finishAuthLogin, i.e. per login or reload). */
const notified = new Set<string>();

/** Test/logout hook: forget who was notified so the next login toasts again. */
export function resetTaskLoginNotice(): void {
  notified.clear();
}

/**
 * Prototype showTaskLoginNotice (line 2332), scheduled 180 ms after finishAuthLogin: toasts
 * 'Ka N detyrë/a të vonuara' or 'Ka N detyrë/a për sot' for the visible open tasks. Runs once per login per
 * page load, however many components mount it.
 */
export function useTaskLoginNotice(): void {
  const { profile } = useAuth();
  const toast = useToast();
  const { visible, loading } = useTasksData();
  const userId = profile?.id ?? null;

  useEffect(() => {
    if (!userId) {
      notified.clear();
      return;
    }
    if (loading || notified.has(userId)) return;
    notified.add(userId);
    const message = loginNotice(visible);
    if (!message) return;
    const timer = setTimeout(() => toast(message), TASK_LOGIN_NOTICE_DELAY_MS);
    return () => clearTimeout(timer);
  }, [userId, loading, visible, toast]);
}
